import AutoNumeric from '@/components/autonumeric/VueAutonumeric';
import localReferences from '@/helpers/localReferences';
import { pickerOptions } from '@/common/pickerOptions';

const expenseMixin = {
    components: {
        AutoNumeric
    },
    data() {
        return {
            localReferences,
            pickerOptions,
            numericOptions: {
                digitGroupSeparator: ' ',
                decimalCharacter: ',',
                decimalPlaces: 0,
                decimalCharacterAlternative: '.',
                roundingMethod: 'U',
                minimumValue: '0',
                maximumValue: '9999999',
                isCancellable: true,
                emptyInputBehavior: 'null',
                modifyValueOnWheel: false
            },
            numericOptionsNegative: {
                minimumValue: '-9999999'
            },
            receivedByTypesList: [
                {
                    id: 'employer',
                    name: 'Сотрудник'
                },
                {
                    id: 'cash',
                    name: 'Касса'
                }
            ],
            receivedFromTypesList: [
                {
                    id: 'cash',
                    name: 'Касса'
                },
                {
                    id: 'employer',
                    name: 'Сотрудник'
                },
                {
                    id: 'contractor',
                    name: 'Контрагент'
                },
                {
                    id: 'factory',
                    name: 'Производство'
                },
                {
                    id: 'contact',
                    name: 'Клиент'
                }
            ],
            receivedFromTypesListRegular: [
                {
                    id: 'cash',
                    name: 'Касса'
                },
                {
                    id: 'contractor',
                    name: 'Контрагент'
                },
                {
                    id: 'employer',
                    name: 'Сотрудник'
                },
                {
                    id: 'contact',
                    name: 'Клиент'
                }
            ],
            receivedFromTypesListDeal: [
                {
                    id: 'employer',
                    name: 'Сотрудник'
                },
                {
                    id: 'cash',
                    name: 'Касса'
                },
                {
                    id: 'factory',
                    name: 'Производство'
                },
                {
                    id: 'contact',
                    name: 'Клиент'
                }
            ],
            expenseTypeList: [
                {
                    id: 'salary',
                    name: 'Зарплата'
                },
                {
                    id: 'salary_cash',
                    name: 'Оклад на руки'
                },
                {
                    id: 'salary_cashless',
                    name: 'Оклад на карту'
                },
                {
                    id: 'bonus',
                    name: 'Ручной бонус'
                },
                {
                    id: 'efficiency_payment',
                    name: 'Бонус за эффективность'
                },
                {
                    id: 'prepayment',
                    name: 'Аванс'
                },
                {
                    id: 'fine',
                    name: 'Ручной штраф'
                },
                {
                    id: 'debt_paid',
                    name: 'Погашение долга'
                },
                {
                    id: 'garbage_removal',
                    name: 'Вывоз мусора'
                },
                {
                    id: 'additional_work',
                    name: 'Дополнительная работа'
                },
                {
                    id: 'visit',
                    name: 'Выезд'
                },
                {
                    id: 'rent',
                    name: 'Аренда'
                },
                {
                    id: 'communications',
                    name: 'Коммуникации'
                },
                {
                    id: 'advertising',
                    name: 'Реклама'
                },
                {
                    id: 'other',
                    name: 'Прочие хоз. расходы'
                },
                {
                    id: 'correction',
                    name: 'Корректировка'
                },
                {
                    id: 'unexpected',
                    name: 'Непредвиденные'
                },
                {
                    id: 'bank_comission',
                    name: 'Комиссия банка'
                },
                {
                    id: 'taxes_fot',
                    name: 'Налоги с ФОТ'
                },
                {
                    id: 'taxes',
                    name: 'Налоги'
                },
                {
                    id: 'production',
                    name: 'Производство'
                },
                {
                    id: 'bonus_1_percent',
                    name: '1% за заключение'
                },
                {
                    id: 'bonus_deal',
                    name: 'Бонус'
                },
                {
                    id: 'fine_deal',
                    name: 'Штраф'
                },
                {
                    id: 'bonus_measurer',
                    name: 'Бонус сверх 50/50'
                },
                {
                    id: 'finish',
                    name: 'Отделка'
                },
                {
                    id: 'jalousie',
                    name: 'Жалюзи'
                },
                {
                    id: 'complaint_materials',
                    name: 'Рекламация. Материалы'
                },
                {
                    id: 'complaint_work',
                    name: 'Рекламация. Работа'
                },
                {
                    id: 'refund_to_client',
                    name: 'Возврат покупателю'
                },
                {
                    id: 'reward_cards',
                    name: 'Вознаграждение по картам'
                },
                {
                    id: 'reward_m_company',
                    name: 'Вознаграждение упр. комп.'
                }
            ],
            receivedFromIdList: []
        };
    },
    computed: {
        employersList() {
            return this.$store.state.references.employers;
        },
        officeList() {
            return this.$store.state.references.offices.filter(office => office.id !== this.localReferences.offices.all);
        },
        receivedByIdList() {
            const recipientType = this.expense.recipient_type;
            if (recipientType === 'cash') {
                return this.cashesList;
            }
            if (recipientType === 'employer') {
                return this.employersList;
            }
            if (recipientType === 'contractor') {
                return this.contractorList;
            }
            if (recipientType === 'factory') {
                return this.factoriesList;
            }
            if (recipientType === 'contact') {
            }
            return [];
        },
        sourceIdList() {
            const sourceType = this.expense.source_type;
            if (sourceType === 'cash') {
                return this.cashList;
            }
            if (sourceType === 'employer') {
                return this.employersList;
            }
            return [];
        },
        receivedByIdListForFilter() {
            const recipientType = this.filterModel.recipient_type;
            if (recipientType === 'cash') {
                return this.cashesList;
            }
            if (recipientType === 'employer') {
                return this.employersList;
            }
            if (recipientType === 'contractor') {
                return this.contractorList;
            }
            if (recipientType === 'factory') {
                return this.factoriesList;
            }
            return [];
        },
        payTypesList() {
            return this.$store.state.references.payTypesCategories || [];
        },
        payTypeList() {
            return this.$store.state.references.payTypes;
        },
        cashList() {
            return this.$store.state.references.cashes;
        },
        cashesList() {
            return this.$store.state.references.cashes.filter(cash => this.localReferences.payTypesCash.includes(cash.pay_type_category_id));
        },
        contractorList() {
            return this.$store.state.references.contractors;
        },
        factoriesList() {
            return this.$store.state.references.factories;
        }
    },
    methods: {
        searchReceivedFrom(query) {
            if (query === '') {
                return [];
            }
            if (this.receivedFromType === 'employer') {
                this.receivedFromIdList = this.employersList.filter(item => {
                    return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
                });
            } else {
                const queryString = query.replace(/[^0-9A-zА-я.@/-]?/g, '');
                this.$store.dispatch('search/searchContactByDeals', { query: queryString }).then(
                    response => {
                        this.receivedFromIdList = [...response];
                    }
                ).catch(() => {
                    this.receivedFromIdList = [];
                });
            }
        },
        getDealLink(dealId) {
            return this.$router.resolve({ name: 'deal-card', params: { id: '' + dealId } }).href;
        },
        getName(obj, field) {
            if (!field || !field.length) return;
            if (Object.keys(obj).length !== 0) {
                if (Array.isArray(field)) {
                    return field.map(id => obj.find(item => item.id === id).name).join(', ');
                } else {
                    return obj.filter(item => item.id === field).map(item => item.name)[0];
                }
            }
        },
        getNameFromListById(list, searchedId) {
            if (Object.keys(list).length !== 0) {
                const foundItem = list.find(item => item.id === searchedId);
                return foundItem ? foundItem.name : '';
            }
            return '';
        },
        getPeriod() {
            if (this.expense.period_month && this.expense.period_year && this.expense.period_month.length > 0 && this.expense.period_year) {
                return '01.' + this.expense.period_month + '.' + this.expense.period_year;
            }
        },
        getCashId(payTypeId, officeId) {
            const cash = this.cashList.filter(item => (item.pay_type_category_id === payTypeId && item.office_id === officeId))[0];
            if (cash !== -1) {
                return cash.id;
            }
            return null;
        },
        getCashByParams(payTypeId, officeId) {
            const cash = this.cashList.filter(item => (item.pay_type_category_id === payTypeId && item.office_id === officeId))[0];
            if (cash !== -1) {
                return cash;
            }
            return null;
        },
        getCash(cashId) {
            const cash = this.cashList.filter(item => (item.id === cashId))[0];
            if (cash !== -1) {
                return cash;
            }
            return null;
        }
    }
};

export default expenseMixin;
